<template>
    <Modal @closeModal="toggleModal" :tabName="selectedTab" />

    <div class="search-bar" @click="toggleModal()" v-show="!isMobile">
        <img
            class="search-icon"
            src="../../../../static/images/icons/aspn_icon/icon_search.png"
        />
        <input
            type="text"
            v-model="search"
            class="search-input"
            :placeholder="$t('SEARCH')"
            readonly
        />
    </div>

    <LoadingAspn type="filter" v-show="isLoading" />

    <!-- <div class="pa-1rem"  v-show="isLoading">
        <div class="skeleton-match__wrapper">
            <div class="mb-2rem">
                <div class="skeleton-child skeleton-match__title"></div>
                <div class="skeleton-child skeleton-match__content"></div>
                <div class="skeleton-child skeleton-match__content"></div>
            </div>
    
            <div class="mb-2rem">
                <div class="skeleton-child skeleton-match__title"></div>
                <div class="skeleton-child skeleton-match__content"></div>
            </div>
    
            <div class="mb-2rem">
                <div class="skeleton-child skeleton-match__title"></div>
                <div class="skeleton-child skeleton-match__content"></div>
                <div class="skeleton-child skeleton-match__content"></div>
            </div>
    
            <div class="mb-2rem">
                <div class="skeleton-child skeleton-match__title"></div>
                <div class="skeleton-child skeleton-match__content"></div>
            </div>
    
            <div class="mb-2rem">
                <div class="skeleton-child skeleton-match__title"></div>
                <div class="skeleton-child skeleton-match__content"></div>
                <div class="skeleton-child skeleton-match__content"></div>
            </div>
    
            <div class="mb-2rem">
                <div class="skeleton-child skeleton-match__title"></div>
                <div class="skeleton-child skeleton-match__content"></div>
                <div class="skeleton-child skeleton-match__content"></div>
            </div>
        </div>
    </div> -->

    <div class="suggestion-container bottom-line" v-show="!isLoading">
        <template v-if="favList?.length > 0 && !isLoading">
            <div class="suggestion-title">
                {{ $t("FAVOURITED") }}
            </div>

            <!-- favourite list -->
            <div class="suggestions-list">
                <div class="suggestions-item" v-for="(item, index) in favList">
                    <router-link
                        :to="urlPath(item)"
                        class="display-flex-center w-100"
                        tag="div"
                    >
                        <leagueIcon
                            :icon="item.leagueKey"
                            v-if="selectedTab === 'COMPETITIONS'"
                            className="suggestions-icon"
                        >
                            <Icon
                                :logoUrl="item.logo"
                                o
                                class="suggestions-icon"
                            ></Icon>
                        </leagueIcon>
                        <Icon
                            :logoUrl="item.logo"
                            o
                            class="suggestions-icon"
                            v-else
                        ></Icon>

                        <!-- <IconMode :light="require('@static/images/icons/aspn_icon/icon_search.png')"
                            class="suggestions-icon" /> -->
                        <div class="suggestions-data">
                            <div class="suggestions-subtitle">
                                {{ item.subtitle }}
                            </div>
                            <div class="suggestions-title">
                                {{ item.name }}
                            </div>
                        </div>
                    </router-link>
                    <div
                        class="pointer"
                        :class="{
                            'btn-fav-aspn': !isMobile,
                            'btn-fav-aspn-mobile': isMobile,
                            selected: item.isFav,
                        }"
                        @click="handleFavToggle(item, $event)"
                    ></div>
                </div>
            </div>
        </template>

        <div v-else>
            <div v-if="!isLoading">
                <NoData
                    class="fav-league-no-fav"
                    text="FAV_MATCH_NO_COMPETITION"
                    v-if="selectedTab === 'COMPETITIONS'"
                />
                <NoData
                    class="fav-team-no-fav"
                    text="FAV_MATCH_NO_TEAMS"
                    v-if="selectedTab === 'TEAMS'"
                />
                <NoData
                    class="fav-player-no-fav"
                    text="FAV_MATCH_NO_PLAYERS"
                    v-if="selectedTab === 'PLAYERS'"
                />
            </div>
        </div>
    </div>

    <!-- suggestion list -->
    <div
        class="suggestion-container"
        v-if="list?.length > 0 && !isLoading"
        :class="{
            'mt-1rem': favList.length === 0,
        }"
    >
        <NoData
            v-if="list?.length === 0 && favList?.length > 0 && !isLoading"
        />

        <template v-if="list?.length > 0">
            <div class="suggestion-title">
                {{ $t("SUGGESTIONS") }}
            </div>

            <div class="suggestions-list">
                <div
                    class="suggestions-item"
                    v-for="(item, index) in list"
                    :key="index"
                >
                    <router-link
                        :to="urlPath(item)"
                        class="display-flex-center w-100"
                        tag="div"
                    >
                        <div class="display-flex-center w-100">
                            <!-- {{ item }} -->
                            <leagueIcon
                                :icon="item.key"
                                v-if="selectedTab === 'COMPETITIONS'"
                                className="suggestions-icon"
                            >
                                <Icon
                                    :logoUrl="item.logo"
                                    o
                                    class="suggestions-icon"
                                ></Icon>
                            </leagueIcon>
                            <Icon
                                :logoUrl="item.logo"
                                o
                                class="suggestions-icon"
                                v-else
                            ></Icon>
                            <!-- <IconMode :light="require('@static/images/icons/aspn_icon/icon_search.png')"
                                class="suggestions-icon" /> -->
                            <div class="suggestions-data">
                                <div class="suggestions-subtitle">
                                    {{ item.subtitle }}
                                </div>
                                <div class="suggestions-title">
                                    {{ item.name }}
                                </div>
                            </div>
                        </div>
                    </router-link>
                    <div
                        class="pointer"
                        v-if="isLogin"
                        :class="{
                            'btn-fav-aspn': !isMobile,
                            'btn-fav-aspn-mobile': isMobile,
                            selected: item.isFav,
                        }"
                        @click="handleFavToggle(item, $event)"
                    ></div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Skeleton from "@/views/notifications/components/Skeleton.vue";
import Modal from "./Modal.vue";
import leagueIcon from "@/components/Icon/LeagueIcon.vue";
export default {
    name: "Suggestions",
    data() {
        return {
            search: "",

            leagueList: [],
            leagueFavList: [],
            teamList: [],
            teamFavList: [],
            playerList: [],
            playerFavList: [],
            suggestionListForAll: {},
            isLoading: false,
        };
    },
    components: {
        Skeleton,
        Modal,
        leagueIcon,
    },
    computed: {
        ...mapGetters([
            "userInfo",
            "isLogin",
            "isMobile",
            "currentSportType",
            "currentLocale",
        ]),
        list() {
            switch (this.selectedTab) {
                case "COMPETITIONS":
                    return this.leagueList;
                    break;
                case "TEAMS":
                    return this.teamList;
                    break;
                case "PLAYERS":
                    return this.playerList;
            }
        },
        favList() {
            switch (this.selectedTab) {
                case "COMPETITIONS":
                    return this.leagueFavList;
                    break;
                case "TEAMS":
                    return this.teamFavList;
                    break;
                case "PLAYERS":
                    return this.playerFavList;
            }
        },
    },
    watch: {
        "$route.name"(newVal) {
            // for webapp change page not trigger init()
            if (this.isMobile) {
                this.init();
            }
        },
    },
    props: {
        selectedTab: String,
    },
    mounted() {
        this.$nextTick(() => {
            this.init();
            this.getSuggestionList();
        });
    },
    methods: {
        ...mapActions([
            "getLeagueListFavV2",
            "getFavLeagueList",
            "favLoginTipsChangeEvent",
            "addFavLeague",
            "unFavLeague",
            "toastrFavChangeEvent",
            "getFavTeamList",
            "addFavTeam",
            "unFavTeam",
            "unFavPlayer",
            "addFavPlayer",
            "getPlayerListFavV2",
            "getFavPlayerList",
            "getFavGlobalPopular",
            "toggleFavModal",
        ]),
        init(key = "") {
            this.isLoading = true;
            switch (key ? key : this.selectedTab) {
                case "COMPETITIONS":
                    this.getLeagueListFavData();
                    break;
                case "TEAMS":
                    this.getTeamListFavData();
                    break;
                case "PLAYERS":
                    this.getPlayerListFavData();
            }
            setTimeout(() => {}, 300);
        },
        async getSuggestionList() {
            let params = {
                token: this.userInfo.token,
                timeZone: this.$tools.getCurrentTimeZone(),
                limit: 10,
            };
            let result;
            if (this.currentSportType == "football") {
                result = await this.getFavGlobalPopular(params);
                this.suggestionListForAll = result.result;
            }
        },

        async getLeagueListFavData() {
            let params = {
                token: this.userInfo.token,
                timeZone: this.$tools.getCurrentTimeZone(),
            };
            const resultFav = await this.getFavLeagueList(params);
            this.leagueFavList = resultFav.result;
            this.initFavInSuggestionsList();
        },
        async getTeamListFavData() {
            let params = {
                token: this.userInfo.token,
                timeZone: this.$tools.getCurrentTimeZone(),
            };
            const resultFav = await this.getFavTeamList(params);
            this.teamFavList = resultFav.result;
            this.initFavInSuggestionsList();
        },
        async getPlayerListFavData() {
            let params = {
                token: this.userInfo.token,
                timeZone: this.$tools.getCurrentTimeZone(),
            };
            const resultFav = await this.getFavPlayerList(params);
            this.playerFavList = resultFav.result;
            this.initFavInSuggestionsList();
        },

        initFavInSuggestionsList() {
            let interval = setInterval(() => {
                if (Object.keys(this.suggestionListForAll).length > 0) {
                    clearInterval(interval);

                    let league = this.suggestionListForAll.competition;
                    let team = this.suggestionListForAll.team;
                    let player = this.suggestionListForAll.player;
                    switch (this.selectedTab) {
                        case "COMPETITIONS":
                            this.leagueList = this.setFavForInitSuggestion(
                                this.leagueFavList,
                                this.suggestionListForAll.competition
                            );
                            break;
                        case "TEAMS":
                            this.teamList = this.setFavForInitSuggestion(
                                this.teamFavList,
                                this.suggestionListForAll.team
                            );
                            break;
                        case "PLAYERS":
                            this.playerList = this.setFavForInitSuggestion(
                                this.playerFavList,
                                this.suggestionListForAll.player
                            );
                            break;
                    }
                    this.$forceUpdate();
                    this.isLoading = false;
                }
            }, 300);
        },
        setFavForInitSuggestion(favList, list) {
            let isFav = [];
            favList.forEach((x) => {
                if (x.isFav) {
                    isFav.push(x.id);
                }
            });
            list.forEach((x) => {
                if (isFav.includes(x.id)) {
                    x["isFav"] = true;
                } else {
                    x["isFav"] = false;
                }
            });
            return list;
        },

        handleFavToggle(item, $event) {
            switch (this.selectedTab) {
                case "COMPETITIONS":
                    this.handleFavLeagueToggle(item, $event);
                    break;
                case "TEAMS":
                    this.handleFavTeamToggle(item, $event);
                    break;
                case "PLAYERS":
                    this.handleFavPlayerToggle(item, $event);
                    break;
            }
        },
        async handleFavLeagueToggle(level2, event) {
            event.preventDefault();

            if (this.isLogin) {
                level2.isFav = !level2.isFav;
                let params = {
                    token: this.userInfo.token,
                    timeZone: this.$tools.getCurrentTimeZone(),
                    leagueId: level2.leagueId ? level2.leagueId : level2.id,
                };

                let res = !level2.isFav
                    ? await this.unFavLeague(params)
                    : await this.addFavLeague(params);

                if (res.result.businessCode === 0) {
                    this.toastrEvent(
                        res,
                        !level2.isFav,
                        level2.countryDisplayName
                            ? level2.countryDisplayName
                            : level2.name
                    );
                    this.$emit("favFilterEmit");
                } else {
                    level2.isFav = !level2.isFav;
                }

                //update favourite league list data
                this.getLeagueListFavData();
            } else {
                this.favLoginTipsChangeEvent({ isOpen: true, event: event });
            }
        },
        async handleFavTeamToggle(level2, event) {
            if (this.isLogin) {
                let params = {
                    teamId: level2.id,
                };
                let paramsToastr = {
                    isOpen: true,
                    msg: level2.name, //this.$i18n.t("TEAM")
                    isAddedFav: false,
                };
                if (level2.isFav) {
                    const result = await this.unFavTeam(params);
                    if (result.message === "Success") {
                        level2.isFav = false;

                        paramsToastr.isAddedFav = false;
                        this.toastrFavChangeEvent(paramsToastr);
                        this.$emit("favTeamSuccess");
                    }
                } else {
                    const result = await this.addFavTeam(params);
                    if (result.message === "Success") {
                        level2.isFav = true;

                        paramsToastr.isAddedFav = true;
                        this.toastrFavChangeEvent(paramsToastr);
                        this.$emit("favTeamSuccess");
                    }
                }
                this.getTeamListFavData();
            }
        },
        async handleFavPlayerToggle(level2, event) {
            if (this.isLogin) {
                let params = {
                    playerId: level2.id,
                };
                let paramsToastr = {
                    isOpen: true,
                    msg: level2.name,
                    isAddedFav: false,
                };
                if (level2.isFav) {
                    const result = await this.unFavPlayer(params);
                    if (result.message === "Success") {
                        level2.isFav = false;

                        paramsToastr.isAddedFav = false;
                        this.toastrFavChangeEvent(paramsToastr);
                    }
                } else {
                    const result = await this.addFavPlayer(params);
                    if (result.message === "Success") {
                        level2.isFav = true;

                        paramsToastr.isAddedFav = true;
                        this.toastrFavChangeEvent(paramsToastr);
                    }
                }
                this.getPlayerListFavData();
            }
        },
        toastrEvent(res, isFav, msg) {
            if (res.result.businessCode === -1) {
            } else {
                let paramsToastr = {
                    isOpen: true,
                    msg: msg,
                    isAddedFav: isFav ? false : true,
                };

                this.toastrFavChangeEvent(paramsToastr);
            }
        },
        selectTab(item) {
            this.tabs.forEach((x) => {
                x.selected = false;
            });

            item.selected = true;
            this.selectedTab = item.name;
            this.init();
        },
        handleRedirect(event) {
            if (this.isDisableRedirect) {
                event.preventDefault();
                event.stopPropagation();
            }
            this.$emit("pageIsRedirected");
        },
        urlPath(item) {
            if (item) {
                if (
                    this.selectedTab === "COMPETITIONS" ||
                    this.selectedTab === "COMPETITION"
                ) {
                    return {
                        path: `/${this.currentLocale}/${this.currentSportType}/${item.countryKey}/${item.key}`,
                        query: {
                            leagueId: item.id,
                        },
                    };
                } else if (this.selectedTab === "TEAMS") {
                    return {
                        path: `/${this.currentLocale}/${
                            this.currentSportType
                        }/team/${item.name.split(" ").join("-")}/${item.id}`,
                    };
                } else {
                    return {
                        path: `/${this.currentLocale}/${
                            this.currentSportType
                        }/player/${item.name.split(" ").join("-")}/${
                            item.id
                        }/overview`,
                    };
                }
            } else {
                return "/";
            }
        },
        toggleModal() {
            this.toggleFavModal();
            !this.isShowFavModal && this.init();
        },
    },
};
</script>

<style scoped>
.suggestion-container-box {
    border-radius: 16px;
    background-color: var(--color-background-default-secondary);
    margin: 16px 8px;
    padding: 16px 0 16px;
}
.fav-title {
    font-size: 20px;
    color: var(--color-text-default-default);
    margin-bottom: 16px;
}
.fav-tabs {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
}
.fav-tab {
    flex: 1;
    padding: 16px;
    text-align: center;
    color: var(--color-text-default-secondary);
    position: relative;
    font-family: var(--weight-600);
    cursor: pointer;
    letter-spacing: 0.64px;
}
.fav-tab.selected {
    color: var(--color-text-default-default);
}
.fav-tab.selected::after {
    content: "";
    position: absolute;
    display: block;
    bottom: 0;
    left: 10%;
    width: 80%;
    height: 2px;
    background-color: var(--color-background-brand-default);
    border-radius: 4px;
}
.search-bar {
    border: 1px solid var(--color-border-default-default);
    padding: 12px 16px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
}
.search-icon {
    width: 24px;
    height: 24px;
}
.search-input {
    letter-spacing: 0.64px;
    color: var(--color-text-default-default);
}
.fav-container {
    width: 380px;
    padding: 16px;
    background-color: var(--color-background-default-secondary);
    border-radius: 16px;
}
.suggestion-container {
}
.suggestion-container.bottom-line {
    border-bottom: 1px dashed var(--color-border-default-default);
    padding-bottom: 16px;
    margin-bottom: 16px;
}
.suggestion-title {
    font-size: 16px;
    color: var(--color-text-default-default);
    margin-bottom: 16px;
    font-family: var(--weight-700);
    letter-spacing: 0.64px;
}
.suggestions-list {
}
.suggestions-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    gap: 12px;
    padding: 8px;
}

.suggestions-data {
    width: 100%;
}
.suggestions-subtitle {
    font-size: 12px;
    color: var(--color-text-default-secondary);
    letter-spacing: 0.2px;
}
.suggestions-title {
    color: var(--color-text-default-default);
    font-size: 14px;
    font-family: var(--weight-600);
    letter-spacing: 0.64px;
}
.btn-fav-aspn {
    width: 22.83px;
    height: 21.8px;
    flex-shrink: 0;
}

.skeleton-match__wrapper {
    width: 100%;
    height: 100%;
    padding: 1rem 0;
    border-radius: 0.5rem;
    box-sizing: border-box;
}

.skeleton-match__title {
    width: 50%;
    height: 1rem;
    margin-bottom: 0.25rem;
}

.skeleton-match__content {
    width: 100%;
    height: 2rem;
    margin-bottom: 0.5rem;
}

@media(max-width: 768px) {
    /* for test */
    .suggestion-container {
        margin: 16px 8px;
        padding: 16px 8px;
        border-radius: 16px;
        background-color: var(--color-background-default-secondary);
    }
    .suggestion-container.bottom-line {
        border-bottom: 0;
        margin-bottom: 0;
    }
    .suggestion-title {
        margin-bottom: 12px;
        font-family: var(--weight-600);
    }
    .fav-container {
        padding: 0;
        width: 100%;
        border-radius: 0;
    }
    .fav-tabs {
        justify-content: center;
        margin-bottom: 0;
    }
    .fav-tab {
        padding: 16px 8px;
        flex: unset;
    }
    .fav-title {
        display: none;
    }
    .suggestions-item {
        background-color: var(--color-background-default-tertiary);
        margin-bottom: 4px;
        border-radius: 8px;
        padding: 16px;
    }
    .suggestions-subtitle {
        font-size: 13px;
    }
    .suggestions-title {
        font-size: 14px;
        letter-spacing: 0.64px;
    }
    .search-bar {
        display: none;
    }
    /* .mobile-tabs {
    display: flex;
    align-items: center;
    justify-content: center;
}
.mobile-tab {
    padding: 16px 8px;
    box-sizing: border-box;
    color: var(--color-text-default-tertiary);
    border-bottom: 2px solid transparent;
    font-family: var(--weight-700);

}
.mobile-tab.selected {
    color: var(--color-text-default-default);
    border-bottom: 2px solid var(--color-background-brand-default);
} */
}
</style>

<style>
.suggestions-icon {
    flex-shrink: 0;
    width: 33.34px;
    height: 33.34px;
    margin-right: 11px;
}
.fav-league-no-fav,
.fav-team-no-fav,
.fav-player-no-fav {
    /* background-color: var(--color-background-default-default) !important; */
    background-color: var(--color-background-default-tertiary);
    /* border: 1px solid var(--color-border-default-default); */
    display: block;
    text-align: center;
}
@media(max-width: 768px) {
    /* for test */
    .suggestions-icon {
        width: 41px;
        height: 41px;
        margin-right: 16px;
    }
}
</style>
